import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class CompleteJobWorkerInterviewRequest extends BaseUpdateRequest {
    jobWorkerInterviewId = '';
    workerFeedback = '';
    contactFeedback = '';
}